import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=0984d4ed&"
import script from "./DocumentTab.vue?vue&type=script&lang=ts&"
export * from "./DocumentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports